<div class="ribbon-group">
  <div class="ribbon-group-content tx-tab-search" [ngClass]="{ 'txui-state-disabled': disabled }">
    <div class="mb-2 tx-tab-find-fields">
      <div class="mb-1">
        <input
          [disabled]="disabled"
          [(ngModel)]="searchTerm"
          type="text"
          id="answerSearch"
          placeholder="Search answer"
          class="px-1" />
      </div>
      <div class="d-flex gap-1">
        <button [disabled]="disabled" type="button" id="findBtn" class="flex-grow-1" (click)="onFindClicked()">
          <i class="bi bi-search"></i>
          Find
        </button>
        <button [disabled]="disabled" type="button" id="clearBtn" class="flex-grow-1" (click)="onClearClicked()">
          <i class="bi bi-x"></i>
          Clear
        </button>
      </div>
    </div>
  </div>
  <div class="ribbon-group-label-container">
    <p class="ribbon-group-label">Search Fields</p>
  </div>
</div>
